import { render, staticRenderFns } from "./Livraison.vue?vue&type=template&id=0bba60c8&"
import script from "./Livraison.vue?vue&type=script&lang=js&"
export * from "./Livraison.vue?vue&type=script&lang=js&"
import style0 from "./Livraison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports